/**
 * Manjares del Sur — storefront behaviors
 */
window.MDS_CONFIG =
  typeof window.MDS_CONFIG === "object" && window.MDS_CONFIG !== null
    ? window.MDS_CONFIG
    : {
        waPhoneDigits: "50671094985",
        whatsappDefaultMessage:
          "Hola Manjares del Sur, quiero hacer un pedido desde la página web:",
      };

const STORAGE_KEY = "mdsBasketV1";

function readBasket() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeBasket(items) {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(items));
}

function basketCount(items) {
  return items.reduce((acc, row) => acc + Number(row.qty || 1), 0);
}

function escapeHtml(str) {
  return String(str || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function waPhone() {
  const cfg = window.MDS_CONFIG || {};
  return String(cfg.waPhoneDigits || "").replace(/\D/g, "");
}

function waUrl(text) {
  const phone = waPhone();
  const body = encodeURIComponent(String(text || "").trim());
  return `https://wa.me/${phone}?text=${body}`;
}

function composeMessage(items, note) {
  const cfg = window.MDS_CONFIG || {};
  const lines = [(cfg.whatsappDefaultMessage || "").trim(), ""];
  if (!items.length) {
    lines.push("(Pedido vacío)");
  } else {
    items.forEach((row, idx) => {
      lines.push(
        `${idx + 1}. ${row.name}${row.sku ? ` (${row.sku})` : ""} × ${Number(row.qty || 1)}`
      );
      if (row.variant) lines.push(`   ${row.variant}`);
    });
  }
  lines.push("", "Notas:", note.trim() ? note.trim() : "—");
  return lines.join("\n");
}

function isMobileUa() {
  return /iPhone|iPad|iPod|Android|webOS|Mobile/i.test(navigator.userAgent);
}

function openWhatsAppOrder(items, note) {
  const url = waUrl(composeMessage(items, note));
  if (!waPhone()) return;

  if (isMobileUa()) {
    window.location.href = url;
    return;
  }

  const a = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  a.rel = "noopener noreferrer";
  document.body.appendChild(a);
  a.click();
  a.remove();
}

function syncBadges(items) {
  const n = basketCount(items);
  document.querySelectorAll("[data-basket-count]").forEach((el) => {
    if (n > 0) {
      el.textContent = String(n);
      el.classList.add("has-count");
      el.setAttribute("aria-hidden", "false");
    } else {
      el.textContent = "";
      el.classList.remove("has-count");
      el.setAttribute("aria-hidden", "true");
    }
  });

  const fabLabel = document.querySelector(".fab-cart__label");
  if (fabLabel) fabLabel.textContent = "Mi pedido";
}

function openWhatsAppCustom(message) {
  const url = waUrl(String(message || "").trim());
  if (!waPhone()) return;
  if (isMobileUa()) {
    window.location.href = url;
    return;
  }
  const a = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  a.rel = "noopener noreferrer";
  document.body.appendChild(a);
  a.click();
  a.remove();
}

window.MDS_OPEN_WA_CUSTOM = openWhatsAppCustom;

window.MDS_ORDER_LINE = function (payload) {
  const items = readBasket();
  const row = {
    name: payload.name,
    sku: payload.sku || "",
    qty: Math.max(1, Number(payload.qty || 1)),
    variant: payload.variant || "",
  };
  const existing = items.findIndex(
    (x) =>
      x.sku === row.sku && x.variant === row.variant && x.name === row.name
  );
  if (existing >= 0) {
    items[existing].qty =
      Number(items[existing].qty || 1) + Number(row.qty || 1);
  } else {
    items.unshift(row);
  }
  writeBasket(items);
  syncBadges(items);
  closeDrawer();
  openCartSheet({ focusNote: false });
};

function sheetOpen() {
  return document.getElementById("cart-sheet")?.classList.contains("is-open");
}

function drawerOpen() {
  return document.getElementById("drawer-panel")?.classList.contains("is-open");
}

function setBodyScrollLock(kind, on) {
  document.body.classList.toggle(`mds-lock-${kind}`, on);
  if (on) {
    document.documentElement.style.overflow = "hidden";
  } else if (!drawerOpen() && !sheetOpen()) {
    document.documentElement.style.overflow = "";
  }
}

function closeDrawer() {
  const drawer = document.getElementById("drawer-panel");
  const overlay = document.getElementById("drawer-overlay");
  const openBtn = document.getElementById("menu-open-btn");
  drawer?.classList.remove("is-open");
  overlay?.classList.remove("is-open");
  drawer?.setAttribute("aria-hidden", "true");
  overlay?.setAttribute("aria-hidden", "true");
  openBtn?.setAttribute("aria-expanded", "false");
  setBodyScrollLock("drawer", false);
}

function openDrawer() {
  const drawer = document.getElementById("drawer-panel");
  const overlay = document.getElementById("drawer-overlay");
  const openBtn = document.getElementById("menu-open-btn");
  if (sheetOpen()) closeCartSheet();
  drawer?.classList.add("is-open");
  overlay?.classList.add("is-open");
  drawer?.setAttribute("aria-hidden", "false");
  overlay?.setAttribute("aria-hidden", "false");
  openBtn?.setAttribute("aria-expanded", "true");
  setBodyScrollLock("drawer", true);
  drawer?.querySelector("[data-drawer-focus]")?.focus();
}

function initDrawer() {
  const openBtn = document.getElementById("menu-open-btn");
  const drawer = document.getElementById("drawer-panel");
  const overlay = document.getElementById("drawer-overlay");
  const panelLinks = drawer
    ? [...drawer.querySelectorAll("[data-drawer-close]")]
    : [];

  openBtn?.addEventListener("click", () =>
    drawer?.classList.contains("is-open") ? closeDrawer() : openDrawer()
  );
  overlay?.addEventListener("click", closeDrawer);
  drawer
    ?.querySelector('[data-role="drawer-dismiss"]')
    ?.addEventListener("click", closeDrawer);

  panelLinks.forEach((el) => {
    el.addEventListener("click", () => {
      if (!el.hasAttribute("data-open-sheet")) closeDrawer();
    });
  });

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    if (sheetOpen()) closeCartSheet();
    else if (drawerOpen()) closeDrawer();
  });
}

function openCartSheet({ focusNote } = { focusNote: true }) {
  const overlay = document.getElementById("cart-sheet-overlay");
  const sheet = document.getElementById("cart-sheet");
  if (!overlay || !sheet) return;
  if (drawerOpen()) closeDrawer();
  overlay.classList.add("is-open");
  sheet.classList.add("is-open");
  overlay.setAttribute("aria-hidden", "false");
  sheet.setAttribute("aria-hidden", "false");
  setBodyScrollLock("sheet", true);
  renderCartSheet(readBasket());
  const note = document.getElementById("cart-note");
  if (focusNote && note) note.focus();
}

function closeCartSheet() {
  const overlay = document.getElementById("cart-sheet-overlay");
  const sheet = document.getElementById("cart-sheet");
  overlay?.classList.remove("is-open");
  sheet?.classList.remove("is-open");
  overlay?.setAttribute("aria-hidden", "true");
  sheet?.setAttribute("aria-hidden", "true");
  setBodyScrollLock("sheet", false);
}

function updateQty(row, delta) {
  const items = readBasket();
  const idx = items.findIndex(
    (x) =>
      x.name === row.name && x.sku === row.sku && x.variant === row.variant
  );
  if (idx < 0) return;
  const next = Number(items[idx].qty || 1) + delta;
  if (next <= 0) items.splice(idx, 1);
  else items[idx].qty = next;
  writeBasket(items);
  syncBadges(items);
  renderCartSheet(items);
}

function removeLine(match) {
  const items = readBasket().filter(
    (row) =>
      !(
        row.name === match.name &&
        row.sku === match.sku &&
        row.variant === match.variant
      )
  );
  writeBasket(items);
  syncBadges(items);
  renderCartSheet(items);
}

function setSheetWaState(items) {
  const waLink = document.getElementById("cart-sheet-wa-link");
  const hint = document.querySelector("[data-sheet-hint]");
  const noteTa = document.getElementById("cart-note");
  const hasItems = items.length > 0;
  const url = waUrl(composeMessage(items, noteTa?.value || ""));

  if (waLink) {
    waLink.href = hasItems && waPhone() ? url : "#";
    waLink.classList.toggle("is-disabled", !hasItems);
    waLink.setAttribute("aria-disabled", hasItems ? "false" : "true");
  }
  if (hint) {
    hint.hidden = hasItems;
  }
}

function renderCartSheet(items) {
  const sheet = document.getElementById("cart-sheet");
  const listRoot = sheet?.querySelector("[data-sheet-items]");
  if (!listRoot) return;

  listRoot.innerHTML = "";

  const titleEl = document.getElementById("cart-sheet-title");
  if (titleEl) titleEl.textContent = items.length ? "Mi pedido" : "Nuevo pedido";

  if (!items.length) {
    const empty = document.createElement("div");
    empty.className = "sheet-empty";
    const catalogHref =
      document.querySelector('.drawer-nav a[href*="catalogo"]')?.href ||
      document.querySelector('.nav-main a[href*="catalogo"]')?.href ||
      "/pages/catalogo";
    empty.innerHTML = `<p><a href="${escapeHtml(catalogHref)}">Ver catálogo</a></p>`;
    listRoot.appendChild(empty);
    setSheetWaState(items);
    return;
  }

  items.forEach((row) => {
    const div = document.createElement("div");
    div.className = "sheet-item";

    const info = document.createElement("div");
    info.className = "sheet-item__info";
    info.innerHTML = `<strong>${escapeHtml(row.name)}</strong>${
      row.variant
        ? `<div class="sheet-item__meta">${escapeHtml(row.variant)}</div>`
        : ""
    }`;

    const controls = document.createElement("div");
    controls.className = "sheet-item__controls";

    const minus = document.createElement("button");
    minus.type = "button";
    minus.className = "qty-btn";
    minus.setAttribute("aria-label", "Menos cantidad");
    minus.textContent = "−";

    const qtySpan = document.createElement("span");
    qtySpan.className = "qty-val";
    qtySpan.textContent = String(row.qty || 1);

    const plus = document.createElement("button");
    plus.type = "button";
    plus.className = "qty-btn";
    plus.setAttribute("aria-label", "Más cantidad");
    plus.textContent = "+";

    minus.addEventListener("click", () => updateQty(row, -1));
    plus.addEventListener("click", () => updateQty(row, 1));

    const remove = document.createElement("button");
    remove.type = "button";
    remove.className = "btn btn--ghost sheet-item__remove";
    remove.textContent = "Quitar";
    remove.addEventListener("click", () => removeLine(row));

    controls.append(minus, qtySpan, plus, remove);
    div.append(info, controls);
    listRoot.appendChild(div);
  });

  setSheetWaState(items);
}

function bindCartTriggers() {
  document.body.addEventListener("click", (e) => {
    const openBtn = e.target.closest("[data-open-sheet]");
    if (openBtn) {
      e.preventDefault();
      if (openBtn.hasAttribute("data-close-drawer")) closeDrawer();
      openCartSheet({ focusNote: openBtn.dataset.focusNote !== "false" });
      return;
    }

    const dismiss = e.target.closest("[data-sheet-dismiss]");
    if (dismiss) {
      e.preventDefault();
      closeCartSheet();
      return;
    }

    const waBtn = e.target.closest("[data-sheet-wa]");
    if (waBtn) {
      if (waBtn.classList.contains("is-disabled")) {
        e.preventDefault();
        return;
      }
      const items = readBasket();
      if (!items.length) {
        e.preventDefault();
        return;
      }
      e.preventDefault();
      const noteTa = document.getElementById("cart-note");
      openWhatsAppOrder(items, noteTa?.value || "");
    }
  });

  document.getElementById("cart-sheet-overlay")?.addEventListener("click", closeCartSheet);

  document.getElementById("cart-note")?.addEventListener("input", () => {
    setSheetWaState(readBasket());
  });

  document.querySelectorAll("[data-wa-prefill]").forEach((btn) =>
    btn.addEventListener("click", () => {
      const cfg = window.MDS_CONFIG || {};
      const base = (cfg.whatsappDefaultMessage || "").trim();
      const extra = btn.getAttribute("data-wa-prefill") || "";
      openWhatsAppCustom(extra ? `${base}\n\n${extra}` : base);
    })
  );
}

const CATALOG_CATS = [
  "tortas",
  "alfajores",
  "cuchuflis",
  "queques",
  "salado",
  "otros",
  "cajas",
];

const CATALOG_CAT_LABEL = {
  all: "Todo el catálogo",
  tortas: "Tortas",
  alfajores: "Alfajores",
  cuchuflis: "Cuchuflís",
  queques: "Queques",
  salado: "Salado rápido",
  otros: "Otros dulces",
  cajas: "Cajas & regalos",
};

function normalizeCatalogSearch(s) {
  return String(s || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{M}/gu, "");
}

function initCatalogFilter() {
  const root = document.getElementById("catalog-filter-root");
  const searchInput = document.getElementById("catalog-search");
  const statusEl = document.getElementById("catalog-filter-status");
  const emptyEl = document.getElementById("catalog-empty");
  const clearBtn = document.getElementById("catalog-search-clear");
  if (!root || !searchInput || !statusEl) return;

  const sections = [...document.querySelectorAll("[data-catalog-section]")];
  const chips = [...root.querySelectorAll("[data-catalog-cat]")];
  let activeCat = "all";

  function setChip(cat) {
    chips.forEach((btn) => {
      const id = btn.getAttribute("data-catalog-cat") || "all";
      const on = id === cat;
      btn.classList.toggle("is-active", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }

  function applyFromHash() {
    const raw = decodeURIComponent(location.hash.replace(/^#/, "").trim());
    if (raw && CATALOG_CATS.includes(raw)) {
      activeCat = raw;
      setChip(raw);
      return true;
    }
    return false;
  }

  function applyCatalogFilter({ scrollSection } = { scrollSection: false }) {
    const qNorm = normalizeCatalogSearch(searchInput.value);
    if (clearBtn)
      clearBtn.hidden = !(searchInput.value && searchInput.value.length);

    let totalVisible = 0;
    sections.forEach((section) => {
      const sid = section.getAttribute("data-catalog-section") || "";
      const isArea = section.hasAttribute("data-catalog-area");
      const matchCat = activeCat === "all" || sid === activeCat;

      if (isArea) {
        const areaText = normalizeCatalogSearch(
          section.getAttribute("data-catalog-search") || ""
        );
        const matchSearch =
          qNorm === "" ||
          areaText.includes(qNorm) ||
          [...section.querySelectorAll("h2, p, button, strong")].some((el) =>
            normalizeCatalogSearch(el.textContent || "").includes(qNorm)
          );
        const visible = matchCat && matchSearch;
        section.hidden = !visible;
        if (visible) totalVisible++;
        return;
      }

      if (!matchCat) {
        section.hidden = true;
        return;
      }

      section.hidden = false;
      let secCount = 0;
      section.querySelectorAll("[data-catalog-item]").forEach((card) => {
        const hay = normalizeCatalogSearch(
          card.getAttribute("data-catalog-search") || ""
        );
        const textHay = hay || normalizeCatalogSearch(card.textContent || "");
        const matchSearch = qNorm === "" || textHay.includes(qNorm);
        card.hidden = !matchSearch;
        if (matchSearch) {
          secCount++;
          totalVisible++;
        }
      });
      if (secCount === 0) section.hidden = true;
    });

    const trimmedQ = searchInput.value.trim();
    const nLabel = `${totalVisible} producto${totalVisible === 1 ? "" : "s"}`;
    let statusMsg = "";
    if (totalVisible === 0) statusMsg = "";
    else if (activeCat === "all" && !trimmedQ)
      statusMsg = `Catálogo completo · ${nLabel}`;
    else {
      const activeChip = chips.find(
        (btn) => (btn.getAttribute("data-catalog-cat") || "") === activeCat
      );
      const catPart =
        activeCat === "all"
          ? "Varias categorías"
          : activeChip?.textContent?.trim() ||
            CATALOG_CAT_LABEL[activeCat] ||
            activeCat;
      statusMsg = trimmedQ
        ? `${catPart} · ${nLabel} que coinciden con «${trimmedQ}»`
        : `${catPart} · ${nLabel}`;
    }
    statusEl.textContent = statusMsg;
    if (emptyEl) emptyEl.hidden = totalVisible > 0;

    if (scrollSection && activeCat !== "all") {
      const target = sections.find(
        (s) => (s.getAttribute("data-catalog-section") || "") === activeCat
      );
      if (target && !target.hidden)
        window.requestAnimationFrame(() =>
          target.scrollIntoView({ block: "start", behavior: "smooth" })
        );
    }
  }

  function resetAllFilters() {
    activeCat = "all";
    setChip("all");
    searchInput.value = "";
    try {
      history.replaceState(null, "", `${location.pathname}${location.search}`);
    } catch {
      /**/
    }
    applyCatalogFilter({ scrollSection: false });
    searchInput.focus();
  }

  chips.forEach((btn) =>
    btn.addEventListener("click", () => {
      activeCat = btn.getAttribute("data-catalog-cat") || "all";
      setChip(activeCat);
      try {
        if (activeCat === "all")
          history.replaceState(null, "", location.pathname + location.search);
        else
          history.replaceState(
            null,
            "",
            `${location.pathname}${location.search}#${activeCat}`
          );
      } catch {
        /**/
      }
      applyCatalogFilter({ scrollSection: true });
    })
  );

  searchInput.addEventListener("input", () =>
    applyCatalogFilter({ scrollSection: false })
  );
  clearBtn?.addEventListener("click", () => {
    searchInput.value = "";
    applyCatalogFilter({ scrollSection: false });
    searchInput.focus();
  });
  root.querySelector("[data-catalog-reset]")?.addEventListener("click", resetAllFilters);
  window.addEventListener("hashchange", () => {
    if (applyFromHash()) applyCatalogFilter({ scrollSection: true });
  });
  applyFromHash();
  applyCatalogFilter({ scrollSection: Boolean(location.hash) });
}

function getPdpFlavor() {
  const input = document.querySelector('input[name="pdp-flavor"]:checked');
  if (!input) return null;
  return {
    value: input.value,
    label: input.dataset.flavorLabel || input.value,
    desc: input.dataset.flavorDesc || "",
    sku: input.dataset.sku || "",
    imageUrl: input.dataset.flavorImage || "",
    imageAlt: input.dataset.flavorImageAlt || input.dataset.flavorLabel || input.value,
  };
}

function getFlavorGalleryImage() {
  const flavor = getPdpFlavor();
  if (!flavor?.imageUrl) return null;
  return { url: flavor.imageUrl, alt: flavor.imageAlt };
}

function getShopifyFlavorValue() {
  const input = document.querySelector('input[name="pdp-flavor"]:checked');
  if (!input) return "";
  const handle = (input.value || "").toLowerCase();
  if (handle === "tradicional") return "Clásica";
  if (handle === "frambuesa") return "Frambuesa";
  if (input.dataset.shopifyOptionValue) return input.dataset.shopifyOptionValue;
  const label = (input.dataset.flavorLabel || "").toLowerCase();
  if (label === "tradicional") return "Clásica";
  if (label === "frambuesa") return "Frambuesa";
  return input.dataset.flavorLabel || input.value || "";
}

function applyFlavorGallery() {
  if (document.querySelector("[data-torta-builder][data-product-backed]")) {
    return false;
  }

  const flavorImg = getFlavorGalleryImage();
  if (flavorImg?.url) {
    updatePdpMainImage(flavorImg.url, flavorImg.alt);
    syncPdpThumbActive(flavorImg.url);
    return true;
  }

  const flavor = getPdpFlavor();
  if (!flavor) return false;

  const thumb = document.querySelector(
    `[data-pdp-thumb][data-flavor="${flavor.value}"]`
  );
  if (thumb) {
    thumb.click();
    return true;
  }
  return false;
}

function syncPdpThumbActive(imageUrl) {
  const target = normalizeImgUrl(imageUrl);
  const gallery = document.querySelector(".pdp-gallery");
  const thumbs = gallery ? [...gallery.querySelectorAll("[data-pdp-thumb]")] : [];
  const match = thumbs.find(
    (thumb) => normalizeImgUrl(thumb.getAttribute("data-full-src") || "") === target
  );
  thumbs.forEach((thumb) => {
    thumb.classList.toggle("is-active", thumb === match);
  });
}

function getPdpEstilo() {
  const input = document.querySelector('input[name="pdp-estilo"]:checked');
  if (!input) return null;
  return {
    value: input.value,
    label: input.dataset.estiloLabel || input.value,
    desc: input.dataset.estiloDesc || "",
  };
}

function getPdpSizeLabel() {
  const size = document.getElementById("pdp-size");
  if (!size || size.tagName !== "SELECT") return "Tamaño a coordinar";
  const sel = size.options[size.selectedIndex];
  return sel?.dataset?.sizeLabel || sel?.textContent?.trim() || "Tamaño a coordinar";
}

function initTortaProductVariants() {
  const root = document.querySelector("[data-torta-builder][data-product-backed]");
  const dataEl = document.getElementById("mds-torta-variants");
  if (!root || !dataEl) return null;

  let variants;
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch {
    return null;
  }

  function getSelectedOptionsByIndex() {
    const byIndex = {};
    root.querySelectorAll("[data-product-option]").forEach((el) => {
      const idx = Number(el.dataset.optionIndex);
      if (Number.isNaN(idx)) return;
      if (el.type === "radio") {
        if (el.checked) byIndex[idx] = el.value;
      } else if (el.tagName === "SELECT") {
        byIndex[idx] = el.value;
      }
    });

    const flavorIdx = root.dataset.flavorOptionIndex;
    const shopifyFlavor = getShopifyFlavorValue();
    if (flavorIdx != null && flavorIdx !== "" && shopifyFlavor) {
      byIndex[Number(flavorIdx)] = shopifyFlavor;
    }

    return byIndex;
  }

  function getSelectedOptions() {
    const byIndex = getSelectedOptionsByIndex();
    return Object.keys(byIndex)
      .sort((a, b) => Number(a) - Number(b))
      .map((key) => byIndex[key]);
  }

  function findVariant() {
    const byIndex = getSelectedOptionsByIndex();
    const selected = Object.keys(byIndex)
      .sort((a, b) => Number(a) - Number(b))
      .map((key) => byIndex[key]);
    const needles = selected.filter(Boolean);
    if (!needles.length) return variants[0];

    const exact = variants.find((variant) => {
      const opts = [variant.option1, variant.option2, variant.option3].filter(Boolean);
      return (
        needles.length === opts.length &&
        needles.every((val, i) => opts[i] === val)
      );
    });
    if (exact) return exact;

    const bySet = variants.find((variant) => {
      const opts = [variant.option1, variant.option2, variant.option3].filter(Boolean);
      return (
        needles.length === opts.length &&
        needles.every((val) => opts.includes(val))
      );
    });
    if (bySet) return bySet;

    return variants.find((variant) => {
      const opts = [variant.option1, variant.option2, variant.option3].filter(Boolean);
      return needles.every((val) => opts.includes(val));
    });
  }

  function applyFlavorFromUrl() {
    const params = new URLSearchParams(location.search);
    const target = (params.get("sabor") || location.hash.replace(/^#/, "")).toLowerCase();
    if (!target) return;

    const blockMatch = [...root.querySelectorAll('input[name="pdp-flavor"]')].find(
      (el) =>
        el.value.toLowerCase() === target ||
        (el.dataset.flavorLabel || "").toLowerCase() === target
    );
    if (blockMatch) {
      blockMatch.checked = true;
      return;
    }

    const match = [...root.querySelectorAll('[data-product-option][type="radio"]')].find(
      (el) => el.value.toLowerCase() === target
    );
    if (match) match.checked = true;
  }

  function syncVariantUi() {
    const variant = findVariant();
    const display = document.querySelector("[data-price-display]");
    const btn = document.getElementById("pdp-add");
    if (display) {
      display.textContent = variant?.priceFormatted || "Consultá precio";
    }
    if (btn) {
      btn.disabled = variant ? !variant.available : variants.length > 0;
    }
    if (variant?.imageUrl) {
      updatePdpMainImage(variant.imageUrl, variant.imageAlt);
      syncPdpThumbActive(variant.imageUrl);
    }
  }

  function onBuilderChange() {
    syncVariantUi();
  }

  root.querySelectorAll("[data-product-option]").forEach((el) => {
    el.addEventListener("change", onBuilderChange);
  });
  root.querySelectorAll('input[name="pdp-flavor"]').forEach((el) => {
    el.addEventListener("change", onBuilderChange);
    el.addEventListener("click", onBuilderChange);
  });

  applyFlavorFromUrl();
  syncVariantUi();

  return { findVariant, variants, syncVariantUi };
}

function syncTortaSelectionNote() {
  const root = document.querySelector("[data-torta-builder]");
  const note = root?.querySelector("[data-flavor-note]");
  if (!note) return;

  const parts = [];
  const flavor = getPdpFlavor();
  const estilo = getPdpEstilo();
  if (flavor?.desc) parts.push(`${flavor.label}: ${flavor.desc}`);
  if (estilo?.desc) parts.push(`${estilo.label}: ${estilo.desc}`);

  note.hidden = parts.length === 0;
  note.textContent = parts.join(" · ");
}

function initTortaEstilo() {
  const root = document.querySelector("[data-torta-builder]");
  if (!root) return;

  root.querySelectorAll('input[name="pdp-estilo"]').forEach((input) => {
    input.addEventListener("change", syncTortaSelectionNote);
  });
  syncTortaSelectionNote();
}

function initTortaFlavor(onChange) {
  const root = document.querySelector("[data-torta-builder]");
  if (!root) return;

  const flavorInputs = [...root.querySelectorAll('input[name="pdp-flavor"]')];
  if (!flavorInputs.length) return;

  function applyFlavorFromUrl() {
    const params = new URLSearchParams(location.search);
    const target = (params.get("sabor") || location.hash.replace(/^#/, "")).toLowerCase();
    if (!target) return;
    const match =
      flavorInputs.find((el) => el.value.toLowerCase() === target) ||
      flavorInputs.find(
        (el) => (el.dataset.flavorLabel || "").toLowerCase() === target
      );
    if (match) match.checked = true;
  }

  function handleChange() {
    syncTortaSelectionNote();
    if (!document.querySelector("[data-torta-builder][data-product-backed]")) {
      applyFlavorGallery();
    }
  }

  flavorInputs.forEach((input) => input.addEventListener("change", handleChange));
  applyFlavorFromUrl();
  handleChange();
}

function initTortaBuilder() {
  initTortaFlavor();
}

function initPdpPriceDisplay() {
  const sizeEl = document.getElementById("pdp-size");
  const display = document.querySelector("[data-price-display]");
  if (!sizeEl || !display) return;

  function syncPrice() {
    const opt = sizeEl.options[sizeEl.selectedIndex];
    const price = opt?.dataset?.price;
    if (price) display.textContent = price;
  }

  sizeEl.addEventListener("change", syncPrice);
  syncPrice();
}

function initProductPdp() {
  const btn = document.getElementById("pdp-add");
  if (!btn) return;

  const productBacked = document.querySelector("[data-product-backed]");
  const tortaVariantsApi = productBacked ? initTortaProductVariants() : null;

  if (!productBacked) {
    initTortaBuilder();
    initPdpPriceDisplay();
  } else if (tortaVariantsApi) {
    initTortaFlavor();
  }
  initTortaEstilo();

  btn.addEventListener("click", () => {
    const qty = document.getElementById("pdp-qty");
    let name = "Producto";
    let sku = "";
    let variantText = "A coordinar";

    const dataEl = document.getElementById("mds-product-data");
    if (dataEl) {
      try {
        const d = JSON.parse(dataEl.textContent);
        name = d.title || name;
        if (d.productBacked && tortaVariantsApi) {
          const variant = tortaVariantsApi.findVariant();
          const estilo = getPdpEstilo();
          const flavor = getPdpFlavor();
          if (variant) {
            sku = variant.sku || sku;
            const optionParts = [variant.option1, variant.option2, variant.option3].filter(
              (opt) => opt && !String(opt).toLowerCase().includes("estilo")
            );
            variantText = optionParts.join(" · ");
            if (flavor && !variantText.toLowerCase().includes(flavor.label.toLowerCase())) {
              variantText = `${flavor.label} · ${variantText}`;
            }
            if (estilo) variantText = `${estilo.label} · ${variantText}`;
            if (variant.priceFormatted) variantText += ` · ${variant.priceFormatted}`;
          } else {
            variantText = [estilo?.label, flavor?.label].filter(Boolean).join(" · ");
          }
          if (!sku && flavor?.sku) sku = flavor.sku;
        } else if (d.productType === "torta-chilena") {
          const flavor = getPdpFlavor();
          const estilo = getPdpEstilo();
          const sizeLabel = getPdpSizeLabel();
          const sizeEl = document.getElementById("pdp-size");
          const priceStr = sizeEl?.options?.[sizeEl.selectedIndex]?.dataset?.price || "";
          if (flavor) {
            name = `Torta Chilena — ${flavor.label}`;
            sku = flavor.sku || sku;
            variantText = estilo
              ? `${estilo.label} · ${flavor.label} · ${sizeLabel}`
              : `${flavor.label} · ${sizeLabel}`;
            if (priceStr) variantText += ` · ${priceStr}`;
          } else {
            variantText = estilo ? `${estilo.label} · ${sizeLabel}` : sizeLabel;
            if (priceStr) variantText += ` · ${priceStr}`;
          }
        } else if (d.sku) {
          sku = d.sku;
        }
        const singleVariantInput = document.querySelector(
          "#pdp-size[data-single-variant]"
        );
        if (singleVariantInput) {
          const parts = [];
          if (d.variantTitle && d.variantTitle !== "Default Title") {
            parts.push(d.variantTitle);
          }
          if (d.variantPrice) parts.push(d.variantPrice);
          if (parts.length) variantText = parts.join(" · ");
        }
      } catch {
        /**/
      }
    }

    const size = document.getElementById("pdp-size");
    if (size && size.tagName === "SELECT") {
      const sel = size.options[size.selectedIndex];
      if (sel) {
        variantText = sel.textContent.trim();
        sku = sel.dataset?.sku || sku;
      }
    }

    const qtyNum =
      qty && qty.valueAsNumber && qty.valueAsNumber > 0 ? qty.valueAsNumber : 1;

    window.MDS_ORDER_LINE({ name, sku, variant: variantText, qty: qtyNum });
  });
}

function initMdsAddButtons() {
  document.querySelectorAll("[data-mds-add]").forEach((btn) =>
    btn.addEventListener("click", () => {
      window.MDS_ORDER_LINE({
        name: btn.getAttribute("data-mds-name") || "Producto",
        sku: btn.getAttribute("data-mds-sku") || "",
        variant: btn.getAttribute("data-mds-variant") || "A coordinar",
        qty: Math.max(1, Number(btn.getAttribute("data-mds-qty") || 1)),
      });
    })
  );
}

function normalizeImgUrl(url) {
  if (!url) return "";
  if (url.startsWith("//")) return `https:${url}`;
  return url;
}

function updatePdpMainImage(url, alt) {
  const mainImg = document.getElementById("pdp-main-img");
  const nextUrl = normalizeImgUrl(url);
  if (!mainImg || !nextUrl) return;

  const current = normalizeImgUrl(mainImg.getAttribute("src") || "");
  if (current === nextUrl) return;

  const applyImage = () => {
    mainImg.src = nextUrl;
    if (alt) mainImg.alt = alt;
    const reveal = () => mainImg.classList.remove("is-swapping");
    if (mainImg.complete) {
      requestAnimationFrame(reveal);
    } else {
      mainImg.addEventListener("load", reveal, { once: true });
    }
  };

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    applyImage();
    return;
  }

  mainImg.classList.add("is-swapping");
  window.setTimeout(applyImage, 180);
}

function initPdpGallery() {
  const gallery = document.querySelector(".pdp-gallery");
  const mainImg = document.getElementById("pdp-main-img");
  if (!gallery || !mainImg) return;

  gallery.addEventListener("click", (event) => {
    const thumb = event.target.closest("[data-pdp-thumb]");
    if (!thumb || !gallery.contains(thumb)) return;

    const thumbs = [...gallery.querySelectorAll("[data-pdp-thumb]")];
    thumbs.forEach((t) => t.classList.toggle("is-active", t === thumb));

    const src = thumb.getAttribute("data-full-src");
    const alt = thumb.getAttribute("data-full-alt");
    updatePdpMainImage(src, alt);
  });
}

function initPdpMobileCta() {
  const stickyWrap = document.querySelector("[data-pdp-mobile-cta]");
  if (!stickyWrap) return;

  const stickyBtn = stickyWrap.querySelector("[data-pdp-add-sticky]");
  const mainAddBtn = document.getElementById("pdp-add");
  const stickyPrice = stickyWrap.querySelector("[data-pdp-mobile-price]");

  if (stickyBtn && mainAddBtn) {
    const syncDisabled = () => {
      stickyBtn.disabled = mainAddBtn.disabled;
    };
    syncDisabled();
    const syncObserver = new MutationObserver(syncDisabled);
    syncObserver.observe(mainAddBtn, {
      attributes: true,
      attributeFilter: ["disabled"],
    });
    stickyBtn.addEventListener("click", () => mainAddBtn.click());
  }

  if (stickyPrice) {
    const priceSource =
      document.querySelector("[data-price-display]") ||
      document.querySelector(".price-hint");
    if (!priceSource) return;

    const syncPrice = () => {
      const text = (priceSource.textContent || "").trim().replace(/\s+/g, " ");
      stickyPrice.textContent = text;
    };
    syncPrice();
    const priceObserver = new MutationObserver(syncPrice);
    priceObserver.observe(priceSource, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }
}

function initHeroHeadline() {
  const rotator = document.querySelector("[data-hero-rotate]");
  if (!rotator) return;

  const phrases = [...rotator.querySelectorAll(".hero-headline__phrase")];
  if (phrases.length < 2) return;

  const headline = rotator.closest("[data-hero-interval]");
  const intervalSec = Number(headline?.dataset?.heroInterval || 5);
  const intervalMs = Math.max(3000, intervalSec * 1000);

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  let index = 0;
  let timer;

  function show(next) {
    const current = phrases[index];
    index = next;
    const incoming = phrases[index];

    current?.classList.remove("is-active");
    current?.classList.add("is-exiting");
    incoming?.classList.add("is-active");

    window.setTimeout(() => {
      current?.classList.remove("is-exiting");
    }, 520);
  }

  function tick() {
    show((index + 1) % phrases.length);
  }

  function start() {
    stop();
    timer = window.setInterval(tick, intervalMs);
  }

  function stop() {
    if (timer) window.clearInterval(timer);
  }

  rotator.addEventListener("mouseenter", stop);
  rotator.addEventListener("mouseleave", start);
  rotator.addEventListener("focusin", stop);
  rotator.addEventListener("focusout", start);

  start();
}

window.addEventListener("DOMContentLoaded", () => {
  const items = readBasket();
  syncBadges(items);
  initDrawer();
  bindCartTriggers();
  renderCartSheet(items);
  initCatalogFilter();
  initProductPdp();
  initMdsAddButtons();
  initPdpGallery();
  initPdpMobileCta();
  initHeroHeadline();
});
